import React, { useState, useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { AiOutlineSend } from "react-icons/ai";
import { FaStop } from "react-icons/fa";
import { TriangleAlert, InfoIcon } from "lucide-react";
import { Typography, Stack } from "@mui/material";
import PaidIcon from "@mui/icons-material/PaidOutlined";
import localization from "services/localization";
import { TrendingUp } from "lucide-react";
import { Button } from "components/ui/button";
import { useUserStore } from "context/useUserStore";

const ChatInput = ({
  onSendMessage,
  showRankingModal,
  messageUploadedLoading,
  totalCredits,
  creditsUsed,
  history_is_disabled,
}) => {
  const [message, setMessage] = useState("");
  const [messageSendingDisabled, setMessageSendingDisabled] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openChatRankingModal, setOpenChatRankingModal] = useState(false);
  const { authUser, appUser, userData } = useUserStore();

  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (creditsUsed >= totalCredits && totalCredits > 0) {
      setMessageSendingDisabled(true);
    } else {
      setMessageSendingDisabled(false);
    }
  }, [creditsUsed, totalCredits]);

  const handleSendMessage = () => {
    if (message.trim() !== "") {
      onSendMessage(message);

      // Center the cursor in the textarea
      if (textareaRef.current) {
        const middlePosition = textareaRef.current.scrollHeight / 2;
        textareaRef.current.scrollTop = middlePosition;
      }
      setMessage("");
    } else {
      setMessage("");
    }
  };

  return (
    <>
      {(history_is_disabled || messageSendingDisabled) && (
        <div className="flex items-center justify-center space-x-3 pt-2 pb-2">
          <TriangleAlert
            size={16}
            color={
              history_is_disabled
                ? "red"
                : messageSendingDisabled
                  ? "orange"
                  : "transparent"
            }
          />
          {history_is_disabled ? (
            <Typography variant="caption" sx={{ fontWeight: 300 }}>
              {localization.history_is_not_active_anymore ||
                "History is not active anymore."}
            </Typography>
          ) : (
            messageSendingDisabled && (
              <Typography variant="caption" sx={{ fontWeight: 300 }}>
                {localization.you_have_reached_the_credit_limit_allocated_to_you ||
                  "You have reached the credit limit allocated to you."}
              </Typography>
            )
          )}
        </div>
      )}

      <div className="flex items-center space-x-3">
        {appUser && appUser.role == "teacher" && (
          <Button
            variant="outline"
            size="icon"
            className="action-btn success w-12 h-12 flex items-center justify-center rounded-full p-0"
            onClick={() => {
              showRankingModal(true);
            }}
          >
            <TrendingUp className="h-6 w-6" />
          </Button>
        )}

        <div className="flex-1 flex items-center bg-[var(--card-bg-color)] rounded-2xl shadow-sm px-4 py-3">
          {appUser && appUser.role == "student" && totalCredits != 0 && (
            <Tooltip
              title={localization.availableCredits || "Available Credits"}
              placement="top"
            >
              <Stack
                direction="column"
                alignItems="center"
                spacing={0.5}
                className="cursor-pointer"
              >
                <PaidIcon sx={{ fontSize: 18, opacity: 0.8 }} />
                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                  {totalCredits - creditsUsed + " / " + totalCredits}
                </Typography>
              </Stack>
            </Tooltip>
          )}
          <textarea
            ref={textareaRef}
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              e.target.style.height = "auto"; // reset height
              e.target.style.height = `${e.target.scrollHeight}px`; // expand
            }}
            rows={2}
            onKeyDown={(e) => {
              if (
                e.key === "Enter" &&
                !e.shiftKey &&
                !messageUploadedLoading &&
                !messageSendingDisabled &&
                !history_is_disabled
              ) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
            placeholder={localization.type_a_message || "Type a message..."}
            className="flex-1 resize-none bg-transparent focus:outline-none text-[var(--main-text-color)] placeholder-gray-400 dark:placeholder-gray-500 min-h-[3rem] py-2 px-2 rounded-xl"
            style={{ maxHeight: "200px", overflowY: "auto" }}
          />
          <button
            onClick={handleSendMessage}
            disabled={
              messageUploadedLoading ||
              messageSendingDisabled ||
              history_is_disabled
            }
            className={`ml-3 p-3 rounded-full text-white ${
              messageUploadedLoading ||
              messageSendingDisabled ||
              history_is_disabled
                ? "action-btn disabled cursor-not-allowed"
                : "action-btn primary"
            }`}
          >
            {messageUploadedLoading ||
            messageSendingDisabled ||
            history_is_disabled ? (
              <FaStop size={20} />
            ) : (
              <AiOutlineSend size={20} />
            )}
          </button>
        </div>
      </div>

      {/* <div className="flex items-center justify-center space-x-1 pt-2">
        <InfoIcon size={14} color={"gray"} />

        <Typography variant="caption" sx={{ fontWeight: 300 }}>
          {localization.input_disclaimer ||
            "Le risposte generate dall'IA possono contenere errori, bias o informazioni inventate. Verifica sempre con fonti autorevoli prima di utilizzare le risposte."}{" "}
          <a
            href="/ai-disclaimer"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:no-underline text-gray-500"
          >
            Learn more
          </a>
        </Typography>
      </div> */}
    </>
  );
};

export default ChatInput;
